import { LogLevel } from '@azure/msal-browser';
import GeneralUtils from './generalUtils';
import AuthUtils from './authUtils';

// for `LocalDev` (local development) use tenantId = `9d3a2809-e0a2-4cfd-b2ce-bd540b6da009` and clientId = `591cf799-7461-4f0b-bc5f-5044e5684126`

const tenantId = AuthUtils.getTenantId();
const clientId = AuthUtils.getClientId();

// const exposeApiId = GeneralUtils.isDevEnvironment() //|| window.location.host.includes('dev4you')
// ? '5ee51967-6ecb-4bea-b004-dbd1b766afe'
// : window.location.host.includes('staging') ? 'cbw0wfcjpkzvfdgysc6d' :'i52984mbdqyop3vku0o3';

 console.log(`Azure ClientId: [${clientId}], Azure TenantId: [${tenantId}]`);
const originalBrowserLocation = Object.assign({}, window.location); // keep original browser URL object (will be reset by Azure `redirectUri: '/'`)
console.log('origLocation :>> ', originalBrowserLocation);
// don't save root domain ROOT initial path ('/'), shortest used path is 5 characters (`about`)
if (
  originalBrowserLocation.pathname.length > 4 &&
  !originalBrowserLocation.pathname.includes('login') &&
  !localStorage.getItem('initialBrowserPath') // when open from PDF/Excel `initialBrowserPath` is reset to `/invoice` so cancel if rewrite if has value
) {
  localStorage.setItem('initialBrowserPath', originalBrowserLocation.pathname + originalBrowserLocation.search);
}



export const msalConfig = {
  auth: {
    authority: `https://login.microsoftonline.com/${tenantId}`, // Tenant ID of the React.JS App Registration
    clientId: `${clientId}`, // Client ID
    redirectUri: '/',
    scopes: [`api://${clientId}/api.scope`],
  },
  // (AD-105) try different config to solve `browserautherror: no_account_error` (https://stackoverflow.com/questions/63347299/unable-to-acquire-token-silently-or-via-redirect-using-msal-browser)
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored // was `sessionStorage`
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge // was `false`
  },
  // graph: {
  //   url: '<your-graph-api-url>',
  //   scopes: '<your-graph-api-scopes>',
  //   response_type: "blob"
  // },
  mode: 'redirect',
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: string, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Can be found in the API Permissions of the ASP.NET Web API
export const loginApiRequest = {
  scopes: [`api://${clientId}/api.scope`],
};
